import { render, staticRenderFns } from "./ProgramSeasonsList.vue?vue&type=template&id=109e0f4a&"
import script from "./ProgramSeasonsList.vue?vue&type=script&lang=js&"
export * from "./ProgramSeasonsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports